import "@/App.css";

// ─── Design tokens (matching vslthealignmentcode.minditpro.com) ───────────────
const BG = "rgb(11, 10, 8)";
const GOLD_GRAD = "linear-gradient(135deg,rgb(191,149,63) 0%,rgb(252,246,186) 25%,rgb(179,135,40) 50%,rgb(251,245,183) 75%,rgb(170,119,28) 100%)";
const GOLD_TEXT = { background: GOLD_GRAD, WebkitBackgroundClip: "text", WebkitTextFillColor: "transparent" };
const GOLD_SOLID = "rgb(212,175,55)";
const TEXT_LIGHT = "rgb(247,245,240)";
const TEXT_MUTED = "rgb(184,176,160)";

const CREATOR_IMG = "https://tagmango.com/staticassets/-1001773107-a912e15a99801a0a41e15f58d9f66e95.png";
const VSL_URL = "https://www.youtube.com/embed/P5yHEKqx86U?rel=0&modestbranding=1";
const CTA_URL = "https://learn.minditpro.com/web/checkout/6a8f43fe960cff3d3ad1ae39";

// ─── Inline SVG icons ──────────────────────────────────────────────────────────
const IconArrow = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M5 12h14"/><path d="m12 5 7 7-7 7"/>
  </svg>
);
const IconUsers = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
    stroke={GOLD_SOLID} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M16 21v-2a4 4 0 0 0-4-4H6a4 4 0 0 0-4 4v2"/>
    <path d="M16 3.128a4 4 0 0 1 0 7.744"/>
    <path d="M22 21v-2a4 4 0 0 0-3-3.87"/>
    <circle cx="9" cy="7" r="4"/>
  </svg>
);
const IconStar = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24"
    fill={GOLD_SOLID} stroke={GOLD_SOLID} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="M11.525 2.295a.53.53 0 0 1 .95 0l2.31 4.679a2.123 2.123 0 0 0 1.595 1.16l5.166.756a.53.53 0 0 1 .294.904l-3.736 3.638a2.123 2.123 0 0 0-.611 1.878l.882 5.14a.53.53 0 0 1-.771.56l-4.618-2.428a2.122 2.122 0 0 0-1.973 0L6.396 21.01a.53.53 0 0 1-.77-.56l.881-5.139a2.122 2.122 0 0 0-.611-1.879L2.16 9.795a.53.53 0 0 1 .294-.906l5.165-.755a2.122 2.122 0 0 0 1.597-1.16z"/>
  </svg>
);
const IconAward = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="15" height="15" viewBox="0 0 24 24" fill="none"
    stroke={GOLD_SOLID} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="m15.477 12.89 1.515 8.526a.5.5 0 0 1-.81.47l-3.58-2.687a1 1 0 0 0-1.197 0l-3.586 2.686a.5.5 0 0 1-.81-.469l1.514-8.526"/>
    <circle cx="12" cy="8" r="6"/>
  </svg>
);
const IconMail = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke={GOLD_SOLID} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <rect width="20" height="16" x="2" y="4" rx="2"/>
    <path d="m22 7-8.97 5.7a1.94 1.94 0 0 1-2.06 0L2 7"/>
  </svg>
);
const IconAlert = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke="rgb(239,68,68)" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <path d="m21.73 18-8-14a2 2 0 0 0-3.48 0l-8 14A2 2 0 0 0 4 21h16a2 2 0 0 0 1.73-3Z"/>
    <path d="M12 9v4"/><path d="M12 17h.01"/>
  </svg>
);
const IconClock = () => (
  <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none"
    stroke={GOLD_SOLID} strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true">
    <circle cx="12" cy="12" r="10"/><polyline points="12 6 12 12 16 14"/>
  </svg>
);

// ─── Hero Section ──────────────────────────────────────────────────────────────
const HeroSection = () => (
  <section
    id="hero"
    data-testid="hero-section"
    style={{ background: BG, paddingTop: 48, paddingBottom: 80, position: "relative", overflow: "hidden" }}
  >
    {/* Background glow */}
    <div style={{
      position: "absolute", inset: 0,
      background: "radial-gradient(at 50% 20%, rgba(212,175,55,0.07) 0%, transparent 58%)",
      pointerEvents: "none"
    }} />

    {/* Content */}
    <div className="fade-up" style={{ maxWidth: 700, margin: "0 auto", padding: "0 24px", textAlign: "center" }}>

      {/* Creator avatar */}
      <div style={{ display: "flex", justifyContent: "center", marginBottom: 18 }}>
        <div style={{ position: "relative", display: "inline-block" }}>
          <div className="pulse-glow" style={{
            position: "absolute", inset: -14, borderRadius: "50%",
            background: "radial-gradient(circle, rgba(212,175,55,0.15) 0%, transparent 68%)",
            pointerEvents: "none"
          }} />
          <div style={{
            position: "relative", borderRadius: "50%", padding: 3,
            background: GOLD_GRAD,
            boxShadow: "rgba(212,175,55,0.22) 0px 0px 36px"
          }}>
            <img
              data-testid="hero-creator-image"
              alt="Vasavi Lakhani — Psychologist and Alignment Expert, Creator of The Alignment Code™"
              src={CREATOR_IMG}
              style={{ width: 120, height: 120, objectFit: "cover", borderRadius: "50%", display: "block" }}
            />
          </div>
        </div>
      </div>

      <p style={{ color: GOLD_SOLID, fontSize: 13, fontWeight: 600, letterSpacing: "0.08em", textTransform: "uppercase", marginBottom: 22 }}>
        Vasavi Lakhani &nbsp;·&nbsp; Psychologist &amp; Alignment Expert
      </p>

      <p style={{ fontSize: 15, color: TEXT_MUTED, lineHeight: 1.65, marginBottom: 14 }}>
        India's First &amp; Only System to{" "}
        <em style={{ color: TEXT_LIGHT }}>"Align Your Mind, Body, Emotions, Nervous System, Identity &amp; Action"</em>
      </p>

      <h1
        data-testid="hero-headline"
        style={{
          fontFamily: '"Cormorant Garamond","Playfair Display",serif',
          fontSize: "clamp(40px,5vw,62px)", fontWeight: 700, lineHeight: 1,
          color: TEXT_LIGHT, marginBottom: 16
        }}
      >
        <span style={GOLD_TEXT}>The Alignment Code™</span>
      </h1>

      <p style={{ fontSize: "clamp(16px,1.9vw,21px)", color: TEXT_LIGHT, fontWeight: 600, lineHeight: 1.5, marginBottom: 0 }}>
        Build <span style={GOLD_TEXT}>SUCCESS</span> that is <strong>STABLE &amp; SUSTAINABLE</strong> using my proven{" "}
        <em>"6D Alignment Framework"</em>
      </p>
    </div>

    {/* VSL Video */}
    <div id="vsl" data-testid="vsl-section" style={{ maxWidth: 900, margin: "40px auto 0", padding: "0 24px" }}>
      <div style={{
        borderRadius: 16, padding: 3,
        background: GOLD_GRAD,
        boxShadow: "rgba(212,175,55,0.22) 0px 0px 70px",
        marginBottom: 36
      }}>
        <div style={{ borderRadius: 14, overflow: "hidden", background: "#000", position: "relative", paddingTop: "56.25%" }}>
          <iframe
            data-testid="vsl-video-player"
            src={VSL_URL}
            title="The Alignment Code™ — Vasavi Lakhani VSL"
            allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
            allowFullScreen
            style={{ position: "absolute", top: 0, left: 0, width: "100%", height: "100%", border: "none" }}
          />
        </div>
      </div>

      {/* CTA */}
      <div style={{ textAlign: "center" }}>
        <a
          href={CTA_URL}
          data-testid="hero-primary-cta"
          target="_blank"
          rel="noopener noreferrer"
          className="cta-shimmer"
          style={{
            display: "inline-flex", alignItems: "center", gap: 10,
            background: GOLD_GRAD,
            color: "rgb(11,10,8)",
            padding: "18px 44px", borderRadius: 7,
            fontWeight: 800, fontSize: 17,
            textDecoration: "none",
            boxShadow: "rgba(212,175,55,0.35) 0px 0px 40px",
            transition: "transform 0.2s, box-shadow 0.2s",
            whiteSpace: "nowrap"
          }}
        >
          Book My Discovery Call <IconArrow />
        </a>

        {/* Social proof */}
        <div style={{ display: "flex", justifyContent: "center", gap: 28, flexWrap: "wrap", marginTop: 24 }}>
          {[
            { icon: <IconUsers />, text: "5,000+ Lives Transformed" },
            { icon: <IconStar />, text: "10+ Years Experience" },
            { icon: <IconAward />, text: "100+ Trainings" },
          ].map(({ icon, text }) => (
            <div key={text} style={{ display: "flex", alignItems: "center", gap: 7 }}>
              {icon}
              <span style={{ color: TEXT_MUTED, fontSize: 13 }}>{text}</span>
            </div>
          ))}
        </div>
      </div>
    </div>
  </section>
);

// ─── Divider ───────────────────────────────────────────────────────────────────
const GoldDivider = () => (
  <div style={{ maxWidth: 900, margin: "0 auto", padding: "0 24px" }}>
    <div style={{ height: 1, background: "linear-gradient(90deg, transparent, rgba(212,175,55,0.4), transparent)" }} />
  </div>
);

// ─── How to Get Started Section ────────────────────────────────────────────────
const steps = [
  {
    num: "1",
    text: "Book your call below and complete the application carefully.",
    type: "normal",
  },
  {
    num: "2",
    text: "We will review your application and contact you if you are qualified.",
    type: "normal",
  },
  {
    num: "3",
    text: "If selected and if you miss your scheduled slot, you will be completely blacklisted.",
    type: "warning",
  },
  {
    num: "4",
    text: "Only 99 members are accepted every 3 months.",
    type: "highlight",
  },
  {
    num: "5",
    text: "The mastermind starts after proper onboarding procedure is completed from our end.",
    type: "normal",
  },
  {
    num: "6",
    text: "Only 5 slots left.",
    type: "urgency",
  },
];

const HowToGetStartedSection = () => (
  <section
    id="how-to-get-started"
    data-testid="how-to-get-started-section"
    style={{ background: BG, paddingTop: 80, paddingBottom: 96, position: "relative", overflow: "hidden" }}
  >
    {/* Background accent */}
    <div style={{
      position: "absolute", inset: 0,
      background: "radial-gradient(at 80% 50%, rgba(212,175,55,0.04) 0%, transparent 60%)",
      pointerEvents: "none"
    }} />

    <div style={{ maxWidth: 700, margin: "0 auto", padding: "0 24px", position: "relative" }}>

      {/* Section header */}
      <div className="fade-up" style={{ textAlign: "center", marginBottom: 56 }}>
        <p style={{ color: GOLD_SOLID, fontSize: 12, fontWeight: 600, letterSpacing: "0.12em", textTransform: "uppercase", marginBottom: 14 }}>
          Your Path Forward
        </p>
        <h2
          data-testid="how-to-get-started-heading"
          style={{
            fontFamily: '"Cormorant Garamond","Playfair Display",serif',
            fontSize: "clamp(32px,4vw,52px)", fontWeight: 700, lineHeight: 1.1,
            color: TEXT_LIGHT, marginBottom: 16
          }}
        >
          How to <span style={GOLD_TEXT}>Get Started</span>
        </h2>
        <p style={{ color: TEXT_MUTED, fontSize: 15, lineHeight: 1.7, maxWidth: 480, margin: "0 auto" }}>
          Follow these steps carefully. This is a selective programme — read every point before you apply.
        </p>
      </div>

      {/* Steps */}
      <ol style={{ listStyle: "none", padding: 0, margin: 0, display: "flex", flexDirection: "column", gap: 20 }}>
        {steps.map((step) => {
          const isWarning = step.type === "warning";
          const isUrgency = step.type === "urgency";
          const isHighlight = step.type === "highlight";

          const cardBg = isWarning
            ? "rgba(239,68,68,0.06)"
            : isUrgency
            ? "rgba(212,175,55,0.08)"
            : "rgba(255,255,255,0.025)";

          const borderColor = isWarning
            ? "rgba(239,68,68,0.3)"
            : isUrgency
            ? "rgba(212,175,55,0.4)"
            : "rgba(212,175,55,0.12)";

          const numBg = isWarning
            ? "rgba(239,68,68,0.18)"
            : GOLD_GRAD;

          const numColor = isWarning ? "rgb(239,68,68)" : "rgb(11,10,8)";
          const textColor = isWarning ? "rgb(252,165,165)" : isUrgency ? GOLD_SOLID : TEXT_LIGHT;

          return (
            <li
              key={step.num}
              data-testid={`step-${step.num}`}
              className="step-card fade-up"
              style={{
                display: "flex",
                alignItems: "flex-start",
                gap: 18,
                background: cardBg,
                border: `1px solid ${borderColor}`,
                borderRadius: 12,
                padding: "20px 24px",
                transition: "transform 0.2s, box-shadow 0.2s",
              }}
            >
              {/* Step number bubble */}
              <div style={{ flexShrink: 0, marginTop: 1 }}>
                <div style={{
                  width: 36, height: 36, borderRadius: "50%",
                  background: isWarning ? "rgba(239,68,68,0.15)" : GOLD_GRAD,
                  border: isWarning ? "1px solid rgba(239,68,68,0.4)" : "none",
                  display: "flex", alignItems: "center", justifyContent: "center",
                  boxShadow: isWarning ? "none" : "rgba(212,175,55,0.25) 0px 0px 12px",
                }}>
                  <span style={{
                    color: numColor,
                    fontWeight: 800, fontSize: 14,
                    fontFamily: "Outfit,sans-serif",
                    background: isWarning ? "none" : undefined,
                    WebkitTextFillColor: isWarning ? "rgb(239,68,68)" : undefined,
                  }}>{step.num}</span>
                </div>
              </div>

              {/* Step text */}
              <div style={{ flex: 1 }}>
                <div style={{ display: "flex", alignItems: "flex-start", gap: 10 }}>
                  {isWarning && <div style={{ marginTop: 2, flexShrink: 0 }}><IconAlert /></div>}
                  {isUrgency && <div style={{ marginTop: 2, flexShrink: 0 }}><IconClock /></div>}
                  <p style={{
                    color: textColor,
                    fontSize: isUrgency ? 17 : 15,
                    fontWeight: isUrgency ? 700 : isHighlight ? 600 : 400,
                    lineHeight: 1.65,
                    margin: 0,
                  }}>
                    {isWarning && (
                      <strong style={{ display: "block", color: "rgb(252,165,165)", marginBottom: 2 }}>Important Notice</strong>
                    )}
                    {step.text}
                  </p>
                </div>
              </div>
            </li>
          );
        })}
      </ol>

      {/* Contact box */}
      <div
        data-testid="contact-box"
        className="fade-up"
        style={{
          marginTop: 44,
          background: "rgba(212,175,55,0.05)",
          border: "1px solid rgba(212,175,55,0.2)",
          borderRadius: 12,
          padding: "24px 28px",
          display: "flex",
          alignItems: "center",
          gap: 14,
          flexWrap: "wrap",
        }}
      >
        <IconMail />
        <div>
          <p style={{ color: TEXT_MUTED, fontSize: 13, margin: "0 0 4px", letterSpacing: "0.03em", textTransform: "uppercase", fontWeight: 600 }}>
            Any questions?
          </p>
          <a
            data-testid="contact-email"
            href="mailto:thealignmentcode.mind@gmail.com"
            style={{
              color: GOLD_SOLID,
              fontSize: 15,
              fontWeight: 600,
              textDecoration: "none",
              borderBottom: "1px solid rgba(212,175,55,0.3)",
              paddingBottom: 1,
              transition: "border-color 0.2s",
            }}
          >
            thealignmentcode.mind@gmail.com
          </a>
        </div>
      </div>

      {/* Final CTA */}
      <div style={{ textAlign: "center", marginTop: 52 }}>
        <a
          href={CTA_URL}
          data-testid="how-to-get-started-cta"
          target="_blank"
          rel="noopener noreferrer"
          className="cta-shimmer"
          style={{
            display: "inline-flex", alignItems: "center", gap: 10,
            background: GOLD_GRAD,
            color: "rgb(11,10,8)",
            padding: "18px 44px", borderRadius: 7,
            fontWeight: 800, fontSize: 17,
            textDecoration: "none",
            boxShadow: "rgba(212,175,55,0.35) 0px 0px 40px",
            transition: "transform 0.2s, box-shadow 0.2s",
            whiteSpace: "nowrap"
          }}
        >
          Book My Call Now <IconArrow />
        </a>
        <p style={{ color: TEXT_MUTED, fontSize: 13, marginTop: 14 }}>
          Only 5 slots remaining — apply while your spot is open
        </p>
      </div>

    </div>
  </section>
);

// ─── Footer ────────────────────────────────────────────────────────────────────
const Footer = () => (
  <footer
    data-testid="footer"
    style={{
      background: "rgb(8,7,6)",
      borderTop: "1px solid rgba(212,175,55,0.1)",
      padding: "32px 24px",
      textAlign: "center"
    }}
  >
    <p style={{ color: "rgba(184,176,160,0.5)", fontSize: 13, margin: 0 }}>
      © {new Date().getFullYear()} The Alignment Code™ by Vasavi Lakhani · Mind IT Pro
    </p>
  </footer>
);

// ─── Root App ──────────────────────────────────────────────────────────────────
function App() {
  return (
    <div
      className="App"
      style={{ background: BG, minHeight: "100vh", fontFamily: 'Outfit,"Plus Jakarta Sans",sans-serif' }}
    >
      <main>
        <HeroSection />
        <GoldDivider />
        <HowToGetStartedSection />
      </main>
      <Footer />
    </div>
  );
}

export default App;
